module.exports = __webpack_public_path__ + "img/status-intransit.c51e549f.svg";